import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpService, HTTP_CONFIG_TOKEN } from './http/http.service';
import { LoggerService, LOGGER_CONFIG_TOKEN } from './logger/logger.service';
import { LoggerConfig } from './logger/logger-config';
import { HttpConfig } from './http/http-config';
import { MainMenuService } from '../shared/services/mainmenu.service';
import { DatetimeToString } from './pipe/pipe-datetime';
import { AmplifyService, AmplifyAngularModule, AmplifyModules } from 'aws-amplify-angular';
import Auth from '@aws-amplify/auth';
import API from '@aws-amplify/api';
import STORAGE from '@aws-amplify/storage';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule, ReactiveFormsModule, AmplifyAngularModule
  ],
  providers: [
    MainMenuService,
    { provide: AmplifyService, useFactory: () => { return AmplifyModules({ Auth, API, STORAGE }); } }
  ],
  exports: []
})
export class CoreModule {

  static forRoot(loggerConfig: LoggerConfig, httpConfig: HttpConfig): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        HttpService,
        LoggerService,
        { provide: LOGGER_CONFIG_TOKEN, useValue: loggerConfig },
        { provide: HTTP_CONFIG_TOKEN, useValue: httpConfig }
      ]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }

}
